module.exports = __webpack_public_path__ + "img/1564014924.e6c8c0c6.jpg";